import React, { ButtonHTMLAttributes } from 'react';
import { InfoIcon, resetButtonStyle } from '@kvdbil/components';
import styled from 'styled-components';
import { useTranslation } from '~/Locale';

const InfoIconBtn = styled.button`
  ${resetButtonStyle}

  &:focus-visible {
    outline: revert;
  }
`;

const StyledInfoIcon = styled(InfoIcon)<{
  $iconSize: number | undefined;
  $isInfoOpened: boolean | undefined;
}>`
  font-size: ${({ $iconSize = 1.375 }) => `${$iconSize}rem`};
  color: ${({ $isInfoOpened, theme }) =>
    $isInfoOpened ? theme.colors.text.dark : theme.colors.grayscaleToned.dark5};

  &:hover {
    color: ${({ theme }) => theme.colors.text.dark};
  }
`;

type CloseProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  iconSize?: number;
  isInfoOpened?: boolean;
  ariaControls?: string;
};

export const Info = ({
  ['aria-label']: ariaLabel,
  iconSize,
  isInfoOpened,
  ariaControls,
  ...rest
}: CloseProps) => {
  const { t } = useTranslation();
  return (
    <InfoIconBtn
      aria-label={ariaLabel ?? t('See more')}
      type="button"
      aria-expanded={isInfoOpened}
      aria-controls={ariaControls}
      {...rest}
    >
      <StyledInfoIcon $iconSize={iconSize} $isInfoOpened={isInfoOpened} />
    </InfoIconBtn>
  );
};
